/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewPasswordRequest
 */
export interface NewPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof NewPasswordRequest
     */
    password?: string;
}

/**
 * Check if a given object implements the NewPasswordRequest interface.
 */
export function instanceOfNewPasswordRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NewPasswordRequestFromJSON(json: any): NewPasswordRequest {
    return NewPasswordRequestFromJSONTyped(json, false);
}

export function NewPasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewPasswordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function NewPasswordRequestToJSON(value?: NewPasswordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
    };
}

